import { SvgChevronleft, SvgChevronright } from '@common/icon';
import { cn } from '@core/utils';
import { createPortal } from 'react-dom';

interface SideNavButtonsProps {
  positions: {
    left: { top: number; left: number };
    right: { top: number; right: number };
  };
  onNextClick: () => void;
  onPrevClick: () => void;
  isNextDisabled: boolean;
  isPrevDisabled: boolean;
}

export const SideNavButtons = ({
  positions,
  onNextClick,
  onPrevClick,
  isNextDisabled,
  isPrevDisabled,
}: SideNavButtonsProps) => {
  if (typeof window === 'undefined') return null;

  return createPortal(
    <>
      {/* 왼쪽 버튼 */}

      <button
        type="button"
        aria-label="이전 리뷰"
        className={cn(
          'fixed z-50 size-52 -translate-y-1/2 rounded-pill border-1 border-Gray-300 bg-Gray-white flex-center',
          {
            'opacity-50 cursor-not-allowed': isPrevDisabled,
          },
        )}
        style={{
          top: positions.left.top,
          left: positions.left.left,
        }}
        onClick={isPrevDisabled ? undefined : onPrevClick}
      >
        <SvgChevronleft className="size-36 text-Gray-600" />
      </button>

      {/* 오른쪽 버튼 */}

      <button
        type="button"
        aria-label="다음 리뷰"
        className={cn(
          'fixed z-50 size-52 -translate-y-1/2 rounded-pill border-1 border-Gray-300 bg-Gray-white flex-center',
          {
            'opacity-50 cursor-not-allowed': isNextDisabled,
          },
        )}
        style={{
          top: positions.right.top,
          right: positions.right.right,
        }}
        onClick={isNextDisabled ? undefined : onNextClick}
      >
        <SvgChevronright className="size-36 text-Gray-600" />
      </button>
    </>,
    document.body,
  );
};
